(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ecCom"), require("mobx"), require("React"), require("mobxReact"), require("ReactRouter"), require("ReactDOM"), require("History"), require("weaDoc"));
	else if(typeof define === 'function' && define.amd)
		define(["ecCom", "mobx", "React", "mobxReact", "ReactRouter", "ReactDOM", "History", "weaDoc"], factory);
	else if(typeof exports === 'object')
		exports["weaDoc"] = factory(require("ecCom"), require("mobx"), require("React"), require("mobxReact"), require("ReactRouter"), require("ReactDOM"), require("History"), require("weaDoc"));
	else
		root["weaDoc"] = factory(root["ecCom"], root["mobx"], root["React"], root["mobxReact"], root["ReactRouter"], root["ReactDOM"], root["History"], root["weaDoc"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_76__, __WEBPACK_EXTERNAL_MODULE_88__, __WEBPACK_EXTERNAL_MODULE_532__, __WEBPACK_EXTERNAL_MODULE_534__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition